import type { ReactElement } from 'react';
import { Link, Navigate } from 'react-router-dom';

import { useVeranstaltungen } from '../../admin/veranstaltungenApi';
import { Karte } from '../../components/Karte';
import { Fehlermeldung } from '../../components/Fehlermeldung';

/**
 * Der Navigationspunkt „Abstimmungen" aus §20.1.
 *
 * Abstimmungen gehören immer zu genau einer Veranstaltung und beginnen je Veranstaltung bei
 * Nummer 1 (§10.2). Eine Liste über alle Veranstaltungen hinweg gäbe es fachlich nicht. Der
 * Navigationspunkt führt deshalb auf die Abstimmungen der **aktiven** Veranstaltung — und, solange
 * keine aktiv ist, auf einen erklärenden Hinweis statt auf eine leere Seite.
 */
export function AbstimmungenWeiche(): ReactElement {
  const veranstaltungen = useVeranstaltungen(false);

  if (veranstaltungen.isPending) {
    return <p className="text-text-gedaempft text-sm">Wird geladen …</p>;
  }

  if (veranstaltungen.isError) {
    return <Fehlermeldung>{veranstaltungen.error.message}</Fehlermeldung>;
  }

  const aktive = veranstaltungen.data.find(
    (eintrag) => eintrag.status === 'freigegeben' || eintrag.status === 'laufend',
  );

  if (aktive !== undefined) {
    return <Navigate to={`/verwaltung/veranstaltungen/${aktive.id}/abstimmungen`} replace />;
  }

  const entwuerfe = veranstaltungen.data.filter((eintrag) => eintrag.status === 'entwurf');

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-semibold">Abstimmungen</h1>

      <Karte>
        <p className="text-sm">
          Derzeit ist keine Veranstaltung freigegeben oder laufend. Abstimmungen gehören immer zu
          einer Veranstaltung und lassen sich dort vorbereiten.
        </p>

        {entwuerfe.length > 0 && (
          <ul className="mt-3 flex flex-col gap-1 text-sm">
            {entwuerfe.map((entwurf) => (
              <li key={entwurf.id}>
                <Link
                  to={`/verwaltung/veranstaltungen/${entwurf.id}/abstimmungen`}
                  className="hover:text-akzent underline"
                >
                  {entwurf.bezeichnung}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </Karte>
    </div>
  );
}
